import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { PrivacyProvider } from './contexts/PrivacyContext';
import { PublicProvider } from './contexts/PublicContext';
import Layout from './components/Layout';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import Configurations from './pages/Configurations';
import InsertData from './pages/InsertData';
import AddFunds from './pages/AddFunds';
import PublicLinks from './pages/PublicLinks';
import PublicDashboard from './components/PublicDashboard';

const AppContent: React.FC = () => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={(token) => window.location.reload()} />;
  }

  return (
    <PrivacyProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/configurations" element={<Configurations />} />
          <Route path="/insert-data" element={<InsertData />} />
          <Route path="/add-funds" element={<AddFunds />} />
          <Route path="/public-links" element={<PublicLinks />} />
        </Routes>
      </Layout>
    </PrivacyProvider>
  );
};

function App() {
  return (
    <AuthProvider>
      <Routes>
        {/* Rota pública sem autenticação */}
        <Route path="/public/:token" element={
          <PublicProvider>
            <PrivacyProvider>
              <PublicDashboard />
            </PrivacyProvider>
          </PublicProvider>
        } />
        {/* Rotas autenticadas */}
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
